export const cityOrStateRegex = /^(?:[A-Za-z]{2,}(?:(\.\s|'s\s|\s?-\s?|\s)?(?=[A-Za-z]+))){1,2}(?:[A-Za-z]+)?$/;
export const cityRegex = /^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ',.\s-]{2,256}$/;
export const streetRegex = /^[a-zA-ZÀ-ÖÙ-öù-ÿĀ-žḀ-ỿ0-9\s,'-.]{2,256}$/;
